module.exports = __webpack_public_path__ + "img/1.8ecb3aa4.jpeg";